import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
const options = [
    {
        value: 'standard',
        label:<IntlMessages id="Label.default"/>,
    },
    {
        value: 'se_bankid',
        label: 'se_bankid',
    },
    {
        value: 'sms_pin',
        label: 'sms_pin',
    },
];
const options1 = [
    {
        value: 'standard',
        label:<IntlMessages id="Label.default"/>,
    },
    {
        value: 'no_bankid',
        label: 'no_bankid',
    },
    {
        value: 'sms_pin',
        label: 'sms_pin',
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function BehorigattvisaInput(props) {
    const classes = useStyles();
    const [Value, setValue] = React.useState(props.Value);
    const Flags = useSelector(state=>state.accountsData.Flags)

    const handleChange = (event) => {
        setValue(event.target.value);
        props.onchangeHanelEvent("Behorigattvisa",event.target.value)
    };

    return (
        <form className={classes.root}>
            <div>
                <TextField
                    select
                    label={<IntlMessages id="E-signing.Authority_to_view"/>}
                    variant="outlined"
                    size="small"
                    value={Value}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    {
                    Flags.BolagData === "NO"?
                    options1.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))
                    :
                    options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
    );
}